import React from "react";
import "antd/dist/antd.css";
import { Button, message } from "antd";
import Amplify, { Auth } from "aws-amplify";
import { Link, withRouter } from "react-router-dom";
import { Row } from "antd";
import { Form, Icon, Input } from "antd";
import newLogo from "../Images/newLogo.JPG";
import { withAppContext } from "../store/contextStore";
import awsConfigure from "../Config/AwsConfig";

Amplify.configure(awsConfigure);

class ForgotPassword extends React.Component {
  state = {
    errors: "",
    loading: false,
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        this.setState({
          loading: true,
        });
        Auth.forgotPassword(values["username"])
          .then((data) => {
            this.props.history.push("/confirm_forgot_password");
          })
          .catch((err) => {
            message.error(err?.message);
            this.setState({
              loading: false,
            });
          });
          localStorage.setItem("forgotEmail", values["username"]);
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div
        style={{ background: "#0E4D90 0% 0% no-repeat padding-box" }}
        className="admin-login-form"
      >
        {/* <div style={{ width: "550px" }}>
          <Row>
            <Col span={6}>
              <img src={newLogo}  alt="Logo" style={{width: '100%'}}/>
            </Col>
            <Col span={18} style={{ marginTop: "30px" }}>
              <span style={{ color: "#FFFFFF" }}>Bulk Material Pro </span>
            </Col>
          </Row>
        </div> */}
        <div className="login-fields">
          <Form onSubmit={this.handleSubmit}>
            <Row>
              {/* <h2 className="Login" style={{ textAlign: "center" }}>Login</h2> */}
              <div style={{ textAlign: "center" }}>
                <img src={newLogo} alt="Logo" style={{ width: "50%" }} />
              </div>
            </Row>
            <Row style={{ textAlign: "center" }}>
              <span style={{ color: "#73818f !important" }}>
                Forgot Password
              </span>
            </Row>
            <Form.Item>
              {getFieldDecorator("username", {
                rules: [
                  {
                    required: true,
                    message: "Please input your Email Address!",
                  },
                ],
              })(
                <Input
                  prefix={
                    <Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />
                  }
                  placeholder="Email Address"
                />
              )}
            </Form.Item>
            <Form.Item className="password-row">
              <Link to="/login">Back</Link>
              <Button
                type="primary"
                htmlType="submit"
                loading={this.state.loading}
                className="login-form-button"
              >
                Submit
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    );
  }
}
const WrappedNormalLoginForm = Form.create({ name: "ForgotPassword" })(
  withAppContext(withRouter(ForgotPassword))
);

export default WrappedNormalLoginForm;